enum IntlNumberNotation {
  Standard = 'standard',
  Compact = 'compact',
}

export default IntlNumberNotation;
